module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/contact-alt-abb4af9250ce6b90934dd351b4d7a7da.jpg";